import { render } from "./YukashoukenSettingSaikenItem.vue?vue&type=template&id=5a727880&ts=true"
import script from "./YukashoukenSettingSaikenItem.vue?vue&type=script&lang=ts"
export * from "./YukashoukenSettingSaikenItem.vue?vue&type=script&lang=ts"

import "./YukashoukenSettingSaikenItem.vue?vue&type=style&index=0&id=5a727880&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__